import React, { useState } from "react";

import { GradientDefs } from "../../GradientDefs";

let maskUid = 0;

/**
 * @component GearFailedIcon
 * @description
 * Outline gear/cog glyph with a cutout in the lower-right corner holding an X
 * badge — used to signify a failed settings/configuration action. The cutout
 * separates the X from the gear outline.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string applied to the stroke.
 *
 * @see https://design.activecollab.com/docs/foundations/icons
 */
const GearFailedIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => {
    const [maskId] = useState(() => `gear-failed-cut-${++maskUid}`);

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        data-testid="GearFailedIcon"
        fill="none"
        stroke={
          gradient
            ? "url(#icon-gradient)"
            : props?.stroke
            ? props.stroke
            : "var(--color-theme-600)"
        }
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        focusable={false}
        ref={ref}
        {...props}
      >
        <GradientDefs gradient={gradient} />
        <defs>
          <mask id={maskId}>
            <rect
              x={0}
              y={0}
              width={24}
              height={24}
              fill="#fff"
              stroke="none"
            />
            <circle cx={17.5} cy={17.5} r={5.5} fill="#000" stroke="none" />
          </mask>
        </defs>
        <g mask={`url(#${maskId})`}>
          <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
          <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
        </g>
        <path d="M15 15l5 5" />
        <path d="M20 15l-5 5" />
      </svg>
    );
  }
);
GearFailedIcon.displayName = "GearFailedIcon";
export default GearFailedIcon;
